import {SearchCond} from "../components/forms/SearchForm";
import {BaseWorldListSortOrderValue} from "../../../constants/constants";
import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";
import {findBaseWorld} from "../../../utils/awsAmplifyUtil";
import {FindBaseWorldResponse} from "../../../types/pj1dbApiWorld";

export interface UseBaseWorldParams {
  searchCond: SearchCond<BaseWorldListSortOrderValue>;
  onChange: (newData: FindBaseWorldResponse[], newStatus: Status) => void;
  enableAutoFetch?: boolean,
  initialStatus?: Status,
}

export function useBaseWorld(params: UseBaseWorldParams) {
  const result = useFetchAllQuery({
    queryFn: (query) => findBaseWorld({
      body: {
        'query-initial': {
          ...(params.searchCond.keyword === "" ? {} : {
            'name-jp': {"$regex": params.searchCond.keyword, "$options": "i"},
          }),
        },
      },
      query
    }),
    needToFetchMore: (data, limit) => Object.entries(data?.items ?? {}).length === limit,
    enableAutoFetch: params.enableAutoFetch,
  });
  const helperResult = useFetchAllQueryHelper({
    onChange: params.onChange,
    data: result.data,
    status: result.status,
    initialStatus: params.initialStatus,
  })


  return {
    ...result,
    ...helperResult,
  }
}
